export const TIPO_RELACION_TITULAR = 1
export const TIPO_RELACION_REPRESENTANTE_LEGAL = 2
export const TIPO_RELACION_PROYECTISTA = 3
export const TIPO_RELACION_CONSULTOR = 4
export const TIPO_RELACION_REPRESENTANTE = 5
export const TIPO_RELACION_ELABORACION_INFORME = 6